import { GET_ALL_BOOKINGS_FAIL, GET_ALL_BOOKINGS_SUCCESS, TRACK_BOOKING_FAIL, TRACK_BOOKING_SUCCESS, GET_BOOKING_BY_BOOKING_NO_FAIL, GET_BOOKING_BY_BOOKING_NO_SUCCESS, GET_BOOKING_BY_CONTAINER_WISE_SUCCESS, GET_BOOKING_BY_CONTAINER_WISE_FAIL, TRACK_BOOKING, GET_BOOKING_BY_BOOKING_PROGRESS, GET_BOOKING_BY_BOOKING_NO_PROGRESS } from "./actionTypes"

//Get All Bookings
const INITIAL_STATE = {
  booking: [],
  error: {}, 
}
const GetAllBookings = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_ALL_BOOKINGS_SUCCESS:
      return {
        ...state,
        booking: action.payload,
      }

    case GET_ALL_BOOKINGS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    default:
      return state
  }
}
export default GetAllBookings

//track booking
const INITIAL_STATE_BOOKING = {
  loading: false,
  track: [],
  error: {},  
}
export const TrackBookings = (state = INITIAL_STATE_BOOKING, action) => {
  switch (action.type) {
    case TRACK_BOOKING:
      return {
        ...state,
        track: action.payload,
        loading: true,
      }
    case TRACK_BOOKING_SUCCESS:
      return {
        ...state,
        track: action.payload,
        loading: false,
      }
    case TRACK_BOOKING_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    default:
      return state
  }
}

//track by booking no
const INITIAL_STATE_BOOKING_BY_NO = {
  data: [],
  error: {},
  loading: false
}
export const GetByBookingNo = (state = INITIAL_STATE_BOOKING_BY_NO, action) => {
  switch (action.type) {
    case GET_BOOKING_BY_BOOKING_NO_PROGRESS:
      return {
        ...state,
        loading: true,
      }
    case GET_BOOKING_BY_BOOKING_NO_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      }
    case GET_BOOKING_BY_BOOKING_NO_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    default:
      return state
  }
}

//track booking by container wise
const INITIAL_STATE_BOOKING_BY_CONTAINER_WISE = {
  data: [],
  error: {}
}
export const GetBookingBYContainerWise = (state = INITIAL_STATE_BOOKING_BY_CONTAINER_WISE, action) => {
  switch (action.type) {
    case GET_BOOKING_BY_CONTAINER_WISE_SUCCESS:
      return {
        ...state,
        data: action.payload,
      }
    case GET_BOOKING_BY_CONTAINER_WISE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    default:
      return state
  }
}